const blogPages = [
    {
    title: 'Best Hair Regrowth Treatments: How to Stop Thinning & Restore Hair Naturally',
    image: require('../blogimg/BestHairRegrowthTreatmentsHowtoStopThinning/hair-intro.jpg'),
    link: '/best-hair-regrowth-treatments-stop-thinning-restore-hair-naturally'
  },
  {
    title: 'Best Hair, Skin & Nails Vitamins vs. Balanced Diet: Which Works Best? (Science-Backed Answer)',
    image: require('../blogimg/HairSkinNailsvsSupplements/hair_skin_intro.jpg'),
    link: '/best-hair-skin-nails-vitamins-vs-balanced-diet'
  },
  {
  title: 'How to Make Rosemary Oil at Home for Stronger, Healthier Hair, Plus The Science Behind How They Work',
  image: require('../blogimg/HowToMakeRosemaryOil/key-ingredients.jpg'),
  link: '/how-to-make-rosemary-oil-at-home-for-stronger-healthier-hair-plus-the-science-behind-how-they-work'
  },
  {
    title: 'What Vitamins Should I Take? A Comprehensive Guide to Essential Nutrients',
    image: require('../blogimg/whatVitaminsShouldITake/whole_foods_plate.jpg'),
    link: '/what-vitamins-should-i-take'
  },
  {
    title: 'Top Vitamin D Foods to Fight Off Vitamin D Deficiency Naturally',
    image: require('../blogimg/vitaminD/salmon.jpg'),
    link: '/top-vitamin-d-foods'
  },
  {
    title: 'High Protein Meals for Muscle Growth',
    image: require('../blogimg/dunkinicream.jpg'),
    link: '/high-protein-meals'
  },
  {
    title: 'Muscle Recovery & Post-Workout Care: Evidence-Based Strategies for Optimal Fitness & Recovery',
    image: require('../blogimg/muscleRecoveryPostWorkout/abstract.jpeg'),
    link: '/muscle-recovery-&-post-workout-care'
  },
    {
    title: 'Deep Vein Thrombosis - How to Prevent It Naturally with Supplements & Lifestyle Tips',
    image: require('../blogimg/DVT/risk_factors.jpg'),
    link: '/deep-vein-thrombosis-how-to-prevent-it-naturally-with-supplements-&-lifestyle-tips'
  },
  {
    title: 'Calming Morning Routine: Simple Ways to Start Your Day at Peace',
    image: require('../blogimg/morningRoutine/transformation.jpg'),
    link: '/calming-morning-routines'
  },
  {
    title: 'Weight Loss Tips: Effective Strategies to Shed Pounds & Stay Healthy',
    image: require('../blogimg/weightloss/weightlossmessage.jpg'),
    link: '/weight-loss-tips'
  },
  {
    title: 'How to Reduce Stress and Anxiety: Scientifically Proven Strategies',
    image: require('../blogimg/howToReduceStressAndAnxiety/stress-anxiety-hero.jpeg'),
    link: '/how-to-reduce-stress-and-anxiety'
  },

  // Add more blog entries here
];

export default blogPages;